import { io } from "socket.io-client";
import constants from "./constants";

const URL = constants.baseUrl;

export const socket = io(URL);
